//Our custom error class that we will throw when we get an error from the api

export type ApiErrorDetails = Record<string, unknown> | string | null;

export class ApiError extends Error {
  override message: string;
  status: number;
  details?: ApiErrorDetails;

  constructor({
    message,
    status,
    details,
  }: {
    message: string;
    status: number;
    details?: ApiErrorDetails;
  }) {
    super(message);
    this.message = message;
    this.status = status;
    this.details = details;
  }
}
